import users from './Users';
import password from './Password';
import multiFactorAuthentication from './MultiFactorAuthentication';

const API = {
  users,
  password,
  multiFactorAuthentication,
};

export default API;
